import { GraviGrid } from '@gravitate-js/excalibrr'
import { detailsColumnDefs } from './DefaultColumnDefs'

type DetailRendererProps = {
  data: {
    details: Gravitate.Order[]
  }
}

export function DetailRenderer({ data }: DetailRendererProps) {
  return (
    <div className='gravi-detail-grid-wrapper'>
      <GraviGrid
        columnDefs={detailsColumnDefs(undefined, true)}
        agPropOverrides={{
          rowGroupPanelShow: 'never',
          getRowId: (params) => `${params.data.order_id}-${params.data.tank_id}-${params.data.destination}`,
          context: { parentData: data },
          suppressRowGroupHidesColumns: true,
          groupDefaultExpanded: -1,
          domLayout: 'autoHeight',
        }}
        sideBar={false}
        rowData={data.details}
      />
    </div>
  )
}
